export default "__VITE_ASSET__fIqxdMeM__"